import { NOT_LOGGED_IN_USER_ID } from '@ori/auth';
import { useEffect } from 'react';

import {
  AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS,
  ISSUER_STORAGE_PARAMETER_FOR_GENESYS,
  REDIRECT_URI,
} from '../constants';
import { useConfiguration, useExternalAuth } from '../contexts';

const waitAndExecute = (callback: () => void, delay: number) => {
  setTimeout(callback, delay);
};
/**
 * Due to iframe and its redirect I have to wait few seconds before I can register plugin.
 */
export const useCreateAuthenticatedSession = () => {
  const { customerId } = useConfiguration();
  const { codeVerifier } = useExternalAuth();

  useEffect(() => {
    if (customerId !== NOT_LOGGED_IN_USER_ID) {
      waitAndExecute(
        () =>
          // eslint-disable-next-line new-cap, @typescript-eslint/no-unsafe-return -- Genesys preset naming,
          window.Genesys?.('registerPlugin', 'AuthProvider', (AuthProvider) => {
            AuthProvider.registerCommand('getAuthCode', (e) => {
              e.resolve({
                authCode: localStorage.getItem(AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS),
                codeVerifier,
                iss: localStorage.getItem(ISSUER_STORAGE_PARAMETER_FOR_GENESYS),
                redirectUri: REDIRECT_URI,
              });
              localStorage.removeItem(AUTH_CODE_STORAGE_PARAMETER_FOR_GENESYS);
            });

            AuthProvider.registerCommand('reAuthenticate', (e) => {
              /*
                      In case there is no valid auth-code or refresh token it should again open login form but in this case we are using hidden iframe.
                     */
              e.resolve(undefined);
            });

            AuthProvider.ready();
          }),
        3000,
      );
    }
  }, [codeVerifier, customerId]);
};
